// Parses Safari version from the user agent. Returns null if not Safari or unparseable.
export const getSafariVersion = (): { major: number; minor: number } | null => {
  const ua = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  if (!isSafari) return null;
  const match = ua.match(/Version\/(\d+)(?:\.(\d+))?/);
  if (!match) return null;
  const major = parseInt(match[1], 10);
  const minor = match[2] !== undefined ? parseInt(match[2], 10) : 0;
  return { major, minor };
};
